<script setup lang="ts">
import { onMounted } from 'vue'

import ErrorText from '@/components/ErrorText.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

onMounted(() => {
  document.title = t('document.inexistantTitle')
})
</script>

<template>
  <ErrorText :text="$t('errors.404')"> 🤷 </ErrorText>
</template>
